import { NotificationService, RecipientTypes, useIntl } from '@capsicum/common';
import { Card, Notification, useRouter } from '@capsicum/common-web';
import { RecipientForm, type RecipientFormShape } from '@capsicum/features/digital-collectibles/web';
import { type ReceiveNetworks, useWalletWithdrawAddRecipientMutation } from '@capsicum/features/wallet/shared';
import styled from 'styled-components';

export const CreateRecipient = () => {
	const { back, searchParams } = useRouter();

	const networkType = searchParams?.get('selectedNetwork') as ReceiveNetworks;

	const { isPending, mutateAsync: createRecipient } = useWalletWithdrawAddRecipientMutation();

	const { $t } = useIntl();

	const texts = {
		alert: $t('wallet.withdraw.recipient.createRecipient.alert'),
		cancel: $t('wallet.withdraw.recipient.createRecipient.cancel'),
		createButtonLabel: $t('wallet.withdraw.recipient.createRecipient.createButtonLabel'),
		notificationSuccess: $t('wallet.withdraw.recipient.createRecipient.notificationSuccess'),
		title: $t('wallet.withdraw.recipient.createRecipient.pageTitle')
	};
	// TODO: blockchainAddress and walletOrExchangeName need BE update to work
	const onFormSubmission = (data: RecipientFormShape) => {
		createRecipient(
			{
				blockchainAddress: data.address.trim(),
				label: data.recipientName.trim(),
				network: networkType,
				type: data.type,
				walletOrExchangeName: data.exchange
			},
			{
				onSuccess: () => {
					back();
					NotificationService.addNotification({
						component: <Notification message={texts.notificationSuccess} variant="success" />
					});
				}
			}
		);
	};

	return (
		<S.Container>
			<S.Title>{texts.title}</S.Title>
			<S.CreateRecipientCard>
				<RecipientForm
					alertText={texts.alert}
					defaultValues={{
						address: '',
						exchange: '',
						recipientName: '',
						type: RecipientTypes.PERSONAL
					}}
					isSaving={isPending}
					networkType={networkType}
					secondaryButtonLabel={texts.cancel}
					submitButtonLabel={texts.createButtonLabel}
					onSecondaryClick={back}
					onSubmitForm={onFormSubmission}
				/>
			</S.CreateRecipientCard>
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div`
		display: flex;
		flex-direction: column;
		width: 100%;
		padding: ${({ theme }) => theme.spacings.medium};
	`;

	export const CreateRecipientCard = styled(Card)`
		display: flex;
		flex-direction: column;
		padding: ${({ theme }) => theme.spacings.medium};
		max-width: 100%;
	`;
	export const Title = styled.p`
		${({ theme }) => theme.fonts.headings.title5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		margin: 0 0 ${({ theme }) => theme.spacings.medium};
	`;
}
